import { POP_UPS_TRANSLATION } from "../../../../constants/translations/customer/PopUps/PopUps"
import { TABLET_VIEW_TRANSLATION } from "../../../../constants/translations/customer/tablet/tabletView"
import { CANCEL, SAVE } from "../../../../constants/translations/review-popup"

export const fileTabBtns = {
    file: {
        name: TABLET_VIEW_TRANSLATION.FILE,
        width: '30%',
        height: '70px',
        color: '#fff',
        backgroundColor: "#186315",
        fontSize: '24px',
        fontWeight: 800,
        icon: true,
        iconContainer: true,
        iconContainerWidth: '32px',
        border: false,
        borderRadius: '90px',
        buttonName: 'AddIcon'
    },
    startTimeCount: {
        name: TABLET_VIEW_TRANSLATION.START_TIME_COUNT,
        width: '40%',
        height: '70px',
        color: '#186315',
        backgroundColor: "#fff",
        fontSize: '24px',
        fontWeight: 800,
        icon: true,
        iconContainer: true,
        iconContainerWidth: '32px',
        border: true,
        borderRadius: '90px',
        buttonName: 'play'
    },
    save: {
        name: SAVE,
        width: '30%',
        height: '70px',
        color: '#fff',
        backgroundColor: "#0091FF",
        fontSize: '24px',
        fontWeight: 800,
        icon: false,
        iconContainer: false,
        border: false,
        borderRadius: '90px',
    },
    cancel: {
        name: CANCEL,
        width: '30%',
        height: '70px',
        color: '#0091FF',
        backgroundColor: "#fff",
        fontSize: '24px',
        fontWeight: 800,
        icon: false,
        iconContainer: false,
        border: true,
        borderRadius: '90px',
    }
}
export const fileTabBtnsDesktop = {
    file: {
        ...fileTabBtns.file,
        height: '52px',
        fontSize: '16px',
        borderRadius: '20px',
        iconContainerWidth: '26px',
        width: '40%',
    },
    save: {
        ...fileTabBtns.save,
        height: '52px',
        fontSize: '16px',
        borderRadius: '20px',
        width: '50%',

    },
    cancel: {
        ...fileTabBtns.cancel,
        height: '52px',
        fontSize: '16px',
        borderRadius: '20px',
        width: '50%',
    }
}

export const fileTabBtnsTablet = {
    startTimeCount: {
        ...fileTabBtns.startTimeCount,
        height: '52px',
        fontSize: '16px',
        borderRadius: '20px',
        iconContainerWidht: '26px',
        width: '50%',
    },
    file: {
        ...fileTabBtns.file,
        height: '52px',
        fontSize: '16px',
        borderRadius: '20px',
        iconContainerWidht: '26px',
        width: '40%',
    },
    save: {
        ...fileTabBtnsDesktop.save,
        with: '35%'
    },
    cancel: {
        ...fileTabBtnsDesktop.cancel,
        with: '35%'
    },
}

export const deleteInfoPopUp = {
    title: POP_UPS_TRANSLATION.DELETE_FILE,
    subtitle: POP_UPS_TRANSLATION.DELETE_FILE_CONFIRMATION,
    info: [
        { label: POP_UPS_TRANSLATION.UPLOADED_BY, value: POP_UPS_TRANSLATION.ZAIN_BATOR },
        { label: POP_UPS_TRANSLATION.UPLOADED_DATE, value: '19/06/2023' },
        { label: POP_UPS_TRANSLATION.FILE_NAME, value: 'Jorem ipsum dolor ' },
        { label: POP_UPS_TRANSLATION.FILE_TYPE, value: 'Jorem ipsum' },

    ]
}
